import React from 'react';
import { AstralInfo } from '../../hooks/useAstralInfo';

const CSS_COLORS: Record<string, string> = {
  'Vermelho':    '#ef4444',
  'Laranja':     '#f97316',
  'Dourado':     '#eab308',
  'Verde':       '#22c55e',
  'Marrom':      '#92400e',
  'Bege':        '#d4b896',
  'Azul':        '#3b82f6',
  'Amarelo':     '#facc15',
  'Branco':      '#f1f5f9',
  'Azul-marinho':'#1e3a5f',
  'Prata':       '#94a3b8',
  'Violeta':     '#8b5cf6',
};

const COLOR_MEANINGS: Record<string, string> = {
  'Vermelho':    'Energia, paixão e vitalidade. Use para revigorar sua determinação.',
  'Laranja':     'Criatividade e entusiasmo. Cor do otimismo e da socialização.',
  'Dourado':     'Prosperidade e sabedoria divina. Conexão com o sagrado.',
  'Verde':       'Cura, crescimento e equilíbrio. Harmonia com a natureza.',
  'Marrom':      'Estabilidade e enraizamento. Confiança e praticidade.',
  'Bege':        'Calma e neutralidade. Abertura para novas perspectivas.',
  'Azul':        'Comunicação e verdade. Clareza mental e serenidade.',
  'Amarelo':     'Alegria, intelecto e otimismo. Energia solar e positividade.',
  'Branco':      'Pureza e renovação. Limpeza energética e novos começos.',
  'Azul-marinho':'Intuição profunda e introspecção. Sabedoria do inconsciente.',
  'Prata':       'Reflexão e sensibilidade lunar. Proteção e clarividência.',
  'Violeta':     'Espiritualidade e transformação. Conexão com planos superiores.',
};

interface Props {
  astralInfo: AstralInfo | null;
}

const CorDoDia: React.FC<Props> = ({ astralInfo }) => {
  if (!astralInfo) return null;

  const name = astralInfo.luckyColors[0];
  const hex = CSS_COLORS[name] || '#8b5cf6';
  const meaning = COLOR_MEANINGS[name] || '';

  return (
    <div className="backdrop-blur-sm rounded-xl overflow-hidden border border-white/20" style={{ background: 'rgba(255,255,255,0.05)' }}>
      <div
        className="h-14 w-full"
        style={{ background: `linear-gradient(90deg, ${hex}cc, ${hex}55)` }}
      />
      <div className="p-4">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-xs font-semibold text-gray-400 uppercase tracking-wide">🎨 Cor do Dia</span>
          <span className="font-bold text-sm" style={{ color: hex }}>{name}</span>
        </div>
        {meaning && <p className="text-xs text-gray-400 leading-relaxed">{meaning}</p>}
      </div>
    </div>
  );
};

export default CorDoDia;
